/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="13.8"
        height="19"
        viewBox="0 0 13.8 19"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M8.58 0H0v19h13.8V5.19L8.62.04Zm4.22 18H1V1h6.87v4.9h4.93Zm-5.75-3.29v1H2.6v-1Zm4.15-3.27v1H2.6v-1Zm0-3.27v1H2.6v-1ZM8.87 1.7l3.21 3.2H8.87Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'PaperFoldedCornerIcon';

export default Icon;
